import api from '../libs/api'
import { getP } from 'redux-polyglot'

/**
 * Actions for initializing the application
 */
export const INIT_APP_REQUEST = 'TOPICS/INIT_APP_REQUEST'

const initAppRequest = () => ({
  type: INIT_APP_REQUEST,
})

export const initApp = () => dispatch => {
  return Promise.all([dispatch(initAppRequest()), dispatch(loadTopics())])
}

export const FETCH_TOPICS_REQUEST = 'TOPICS/FETCH_TOPICS_REQUEST'
export const FETCH_TOPICS_SUCCESS = 'TOPICS/FETCH_TOPICS_SUCCESS'
export const FETCH_TOPICS_FAILURE = 'TOPICS/FETCH_TOPICS_FAILURE'

export const fetchTopicsRequest = () => ({
  type: FETCH_TOPICS_REQUEST,
})

export const fetchTopicsSuccess = topicsPlan => {
  let topics = []
  if (topicsPlan.length > 0) {
    topicsPlan.forEach(topic => {
      topics.push({
        id: topic.id,
        name: topic.name,
        icon: topic.icon,
        order: topic.topic_order,
        is_support: topic.is_support,
        page_id: topic.page_id,
        topicsRequested: false,
      })
    })
  }

  return {
    type: FETCH_TOPICS_SUCCESS,
    payload: {
      topics,
    },
  }
}

export const fetchTopicsFailure = error => ({
  type: FETCH_TOPICS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})
export const FOCUS_TOPIC = 'TOPICS/FOCUS_TOPIC'
export const focusTopic = id => ({
  type: FOCUS_TOPIC,
  payload: {
    id,
  },
})
export const FOCUS_TOPIC_POSITION = 'TOPICS/FOCUS_TOPIC_POSITION'
export const focusTopicPosition = position => ({
  type: FOCUS_TOPIC_POSITION,
  payload: {
    position,
  },
})

export const SELECT_TOPIC = 'TOPICS/SELECT_TOPIC'
export const selectTopicRequest = id => ({
  type: SELECT_TOPIC,
  payload: {
    id,
  },
})

export const selectTopic = id => (dispatch, getState) => {
  dispatch(selectTopicRequest(id))
}

export const loadTopics = () => (dispatch, getState) => {
  dispatch(fetchTopicsRequest())
  return api
    .getTopics()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(fetchTopicsSuccess(response.topics))
        } else {
          return dispatch(fetchTopicsFailure(response.reason))
        }
      },
      () =>
        dispatch(
          fetchTopicsFailure(
            getP(getState()).t('support_app.error_loading_topics', {
              _: 'An error occurred while retrieving topics application',
            })
          )
        )
    )
}

export const DISMISS_ERROR = 'TOPICS/DISMISS_ERROR'
export const dismissError = () => ({
  type: DISMISS_ERROR,
})
